import { BrokerNerdsBarkerCoreModelsPricingRuleFilters } from '../api';

export function normalizePricingRuleFilters(
  filters: BrokerNerdsBarkerCoreModelsPricingRuleFilters,
): BrokerNerdsBarkerCoreModelsPricingRuleFilters {
  if ((filters.sectionRows?.length ?? 0) === 0) {
    return filters;
  }

  return {
    ...filters,
    rows: undefined,
    sectionIds: [],
  };
}
